import React, { useState, useEffect } from "react";
import axios from 'axios';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Drawer, Grid, Tooltip, Typography, IconButton } from "@material-ui/core";
import PrimaryButton from '../PrimaryButton';
import CloseIcon from "../../icons/CloseIcon";
import DocIcon from "../../icons/DocIcon";
import AddedIcon from "../../icons/AddedIcon";
import CustomInput from '../CustomInput';
import DropZone from '../dropzone/DropZone';
import translate from '../../other/translate.json';
import config from '../../other/config';
const { serverAPI } = config;



export default function BasketAskCFT(props) {
  //const [usname, setUsname] = useState('');// codeerr arh это нахера нам? если мы его не юзаем
  let lang = localStorage.getItem('language') || 'Ru'
  const {isAuth, usname} = props;
  const classes = useStyles();
  // const [state, setState] = React.useState(false);
  //const [isAuth, _isAuth] = useState(false);
  const [authFio, _authFio] = useState('');
  const [authBank, _authBank] = useState('');
  const [authPosition, _authPosition] = useState('');
  const [authMobile, _authMobile] = useState('');
  const [authMail, _authMail] = useState('');
  const [fio, setFio] = useState('');
  const [bank, setBank] = useState('');
  const [position, setPosition] = useState('');
  const [mobile, setMobile] = useState('');
  const [mail, setMail] = useState('');
  const [letter, setLetter] = useState('');
  const [answer, setAnswer] = useState('');
  const [pdn, _pdn] = useState(false);

  useEffect(() => {
    // if (props.isAuth == true) {
    let didCancel = false;
    async function fetchData() {
      const login = usname//await axios.get(`${serverAPI}/auth`);
      if (!didCancel) {
        console.log("bacft-auth",login)
        if (login && login) {
          //_isAuth(true);
          _authFio(login.usname);
          _authBank(login.organization);
          _authPosition(login.title);
          _authMobile(login.phone);
          _authMail(login.email);
          setFio(login.usname)
          setBank(login.organization)
          setPosition(login.title)
          setMobile(login.phone)
          setMail(login.email)
        }
      }
    }

    fetchData();

    return () => {
      didCancel = true;
    };
    // }
  }, [isAuth]);

  let { stateAsk, setStateAsk } = props

  function toggleDrawer(open, event) {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    // setState(open);
  };

  function closeDrawer() {
    setStateAsk(false)
    setAnswer('')
  }

  function cutFioValue(value) {
    const shouldSetValue = value.length < 256

    if (shouldSetValue) setFio(value.replace(/ +/g, ' '))
  }

  function cutMailValue(value) {
    const shouldSetValue = value.length < 255

    if (shouldSetValue) setMail(value.replace(/ +/g, ' '))
  }

  function cutBankValue(value) {
    const shouldSetValue = value.length < 256

    if (shouldSetValue) setBank(value.replace(/ +/g, ' '))
  }

  function cutPositionValue(value) {
    const shouldSetValue = value.length < 256

    if (shouldSetValue) setPosition(value.replace(/ +/g, ' '))
  }

  function cutMobileValue(value) {
    const shouldSetValue = value.length < 51

    if (shouldSetValue) setMobile(value.replace(/ +/g, ' '))
  }

  function cutLetterValue(value) {
    const shouldSetValue = value.length < 256

    if (shouldSetValue) setLetter(value.replace(/ +/g, ' '))
  }

  async function sendmail() {
    const prodBasketNew = JSON.parse(localStorage.getItem('cartProd')) || ''
    const appBasketNew = JSON.parse(localStorage.getItem('cartApp')) || ''
    const cloudBasket = JSON.parse(localStorage.getItem('cartCloud')) || ''

    let body = 'body_'
    let sender = fio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/) ? fio.trim() : '';
    let senderbank = bank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? bank.trim() : ''
    let senderposition = position.trim()
    let senderphone = mobile.trim()
    let sendermail = mail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? mail.trim() : '';

    if (sender !== '' && senderbank !== '' && sendermail !== '') {
      const sendmail_res = await axios.post(`${serverAPI}/sendmail`,//await axios.post(`https://catalog.cft.ru/sendmail`,
        { body, sender, senderbank, senderposition, senderphone, sendermail, letter, 'link': props.link ? props.link : `${serverAPI}/export2/complectation?applications=${appBasketNew}&products=${prodBasketNew}&clouds=${cloudBasket}` }
      )
      // closeDrawer()
      setAnswer(sendmail_res.data.result)
    }
  }

  async function sendConsent() {
    let sender = fio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/) ? fio.trim() : '';
    let senderbank = bank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? bank.trim() : ''
    let senderposition = position.trim()
    let senderphone = mobile.trim()
    let sendermail = mail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? mail.trim() : '';

    if (sender !== '' && senderbank !== '' && sendermail !== '') {
      const sendConsent_res = await axios.post(`${serverAPI}/sendConsent`,
        { sender, senderbank, senderposition, senderphone, sendermail, IdInterview: 'consent' }
      );

      setAnswer(sendConsent_res.data.result);
      sendmail();
    }
  }

  function list(anchor) {
    return (
      <div
        className={classes.list}
        role="presentation"
        onClick={() => toggleDrawer(anchor, false)}
        onKeyDown={() => toggleDrawer(anchor, false)}
        style={{ overflowX: 'hidden', overflowY: 'auto', scrollbarWidth: 'thin' }}
      >
        <Grid
          container
          direction="column"
          justify="flex-start"
          className={classes.root}
        >
          <Grid item container>
            <Grid className={classes.btnClose}>
              <IconButton onClick={() => closeDrawer()} aria-label="filter" className={classes.btnFilter}>
                <CloseIcon fill='#BCBBD0' />
              </IconButton>
            </Grid>

            <Grid item style={{ marginTop: 14 }}>
              <Typography className={classes.listHeader}>{translate.Discuss[`RequestToOptimize${lang}`]}    </Typography>
            </Grid>
          </Grid>

          <Grid item container direction="column" style={{ marginTop: 29 }}>
            <Grid item>
              <form className={classes.rootForm} noValidate>
                <Grid container direction="column">
                  <Grid item>
                    <CustomInput
                      disabled={authFio.length > 1}
                      error={fio.trim() === '' || fio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/) ? false : true}
                      valid={fio.trim() !== '' && fio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/) ? true : false}
                      helperText={fio === '' ? translate.Discuss[`MandatoryField${lang}`] : fio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/) ? translate.Discuss[`MandatoryField${lang}`] : translate.Discuss[`EnterTheCorrectData${lang}`]}
                      value={fio}
                      onChange={(e) => cutFioValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`LetterFullNamen_${lang}`]}
                      hint={true}
                    />
                  </Grid>

                  <Grid item>
                    <CustomInput
                      disabled={authMail.length > 1}
                      error={mail.trim() === '' || mail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? false : true}
                      valid={mail.trim() !== '' && mail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? true : false}
                      helperText={mail === '' ? translate.Discuss[`MandatoryField${lang}`] : mail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? translate.Discuss[`MandatoryField${lang}`] : translate.Discuss[`EnterTheCorrectEmail${lang}`]}
                      value={mail}
                      onChange={(e) => cutMailValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`Email${lang}`]}
                      hint={true}
                    />
                  </Grid>

                  <Grid item>
                    <CustomInput
                      disabled={authBank.length > 1}
                      error={bank.trim() === '' || bank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? false : true}
                      valid={bank.trim() !== '' && bank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? true : false}
                      helperText={bank === '' ? translate.Discuss[`MandatoryField${lang}`] : bank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? translate.Discuss[`MandatoryField${lang}`] : translate.Discuss[`EnterTheCorrectData${lang}`]}
                      value={bank}
                      onChange={(e) => cutBankValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`Company${lang}`]}
                      hint={true}
                    />
                  </Grid>

                  <Grid item>
                    <CustomInput
                      disabled={authPosition.length > 1}
                      value={position}
                      onChange={(e) => cutPositionValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`Position${lang}`]}
                    />
                  </Grid>

                  <Grid item>
                    <CustomInput
                      disabled={authMobile?.length > 1} 
                      value={mobile}
                      onChange={(e) => cutMobileValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`ContactPhone${lang}`]}
                    />
                  </Grid>

                  <Grid item>
                    <CustomInput
                      value={letter}
                      onChange={(e) => cutLetterValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`TypeYourTextHere${lang}`]}
                    />
                  </Grid>

                  <Grid item container>
                    <Grid
                      container
                      direction="row"
                      justify="space-between"
                      alignItems="center"
                      style={{ width: '100%', padding: '36px 0 28px' }}
                    >
                      <Grid item container direction="row" style={{ width: "100%" }}>
                        <Grid item>
                          <DocIcon fill={'#BCBBD0'} />
                        </Grid>

                        <Grid item style={{ marginLeft: 8 }}>
                          <Typography className={classes.Caption1}>{translate.Discuss[`SelectedPackageAttached${lang}`]}</Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            </Grid>

            <Grid item container direction="row" alignItems="center" className={classes.ActionArea}>
              <Grid item>
                <PrimaryButton
                  disabled={
                    (fio.trim() !== '' && fio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/))
                      &&
                      (mail.trim() !== '' && mail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i))
                      &&
                      (bank.trim() !== '' && bank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/))
                      &&
                      ((JSON.parse(localStorage.getItem('cartProd')) ? JSON.parse(localStorage.getItem('cartProd')).length !== 0 : true) || JSON.parse(localStorage.getItem('cartApp')).length !== 0 || JSON.parse(localStorage.getItem('cartCloud')).length !== 0)
                      ?
                      false
                      :
                      true
                  }
                  height={55}
                  text={translate.Discuss[`Send_${lang}`]}
                  onClick={() => sendmail()}
                />
              </Grid>
            </Grid>

            <Grid item style={{ marginTop: 24 }}>

            </Grid>
          </Grid>
        </Grid>
      </div>
    )
  };

  function listSubmitTrue() {
    return (
      <div
        className={classes.list}
        role="presentation"
      >
        <Grid
          container
          direction="column"
          justify="center"
          className={classes.root}
          style={{ padding: 64, paddingTop: 254 }}
        >
          <Grid item container direction="column" justify="center" alignItems="center">
            <Grid className={classes.btnClose}>
              <IconButton onClick={() => closeDrawer()} aria-label="filter" className={classes.btnFilter}>
                <CloseIcon fill='#BCBBD0' />
              </IconButton>
            </Grid>

            <Grid item style={{ marginTop: 30 }}>
              <Grid
                container
                justify="center"
                alignItems="center"
                style={{ width: 72, height: 72, backgroundColor: '#81D39D', borderRadius: '50%', boxShadow: 'none' }}
              >
                <AddedIcon fill={'#FFFFFF'} />
              </Grid>
            </Grid>

            <Grid item style={{ marginTop: 30 }}>
              <Typography className={classes.listHeader} style={{ textAlign: 'center' }}>{translate.Discuss[`YouRequest${lang}`]}</Typography>
              <Typography className={classes.listHeader} style={{ textAlign: 'center' }}>{translate.Discuss[`Successfully${lang}`]}</Typography>
            </Grid>

            <Grid item style={{ marginTop: 40 }}>
              <PrimaryButton onClick={() => closeDrawer()} height={55} text={'Закрыть'} />
            </Grid>
          </Grid>
        </Grid>
      </div>)
  };

  function listSubmitFalse() {
    return (
      <div
        className={classes.list}
        role="presentation"
      >
        <Grid
          container
          direction="column"
          justify="center"
          className={classes.root}
          style={{ padding: 64, paddingTop: 254 }}
        >
          <Grid item container direction="column" justify="center" alignItems="center">
            <Grid className={classes.btnClose}>
              <IconButton onClick={() => closeDrawer()} aria-label="filter" className={classes.btnFilter}>
                <CloseIcon fill='#BCBBD0' />
              </IconButton>
            </Grid>

            <Grid item>
              <Grid
                container
                justify="center"
                alignItems="center"
                style={{ width: 72, height: 72, backgroundColor: '#BCBBD0', borderRadius: '50%', boxShadow: 'none' }}
              >
                <CloseIcon fill={'#FFFFFF'} />
              </Grid>
            </Grid>

            <Grid item style={{ marginTop: 30 }}>
              <Typography className={classes.listHeader} style={{ textAlign: 'center' }}>По техническим причинам</Typography>
              <Typography className={classes.listHeader} style={{ textAlign: 'center' }}>сервис временно недоступен.</Typography>
            </Grid>

            <Grid item style={{ marginTop: 24 }}>
              <Typography className={classes.Body1}>Попробуйте повторно позднее.</Typography>
            </Grid>

            <Grid item style={{ marginTop: 40 }}>
              <PrimaryButton onClick={() => closeDrawer()} height={55} text={'Закрыть'} />
            </Grid>
          </Grid>
        </Grid>
      </div>
    )
  };

  return (
    <div>
      <React.Fragment key="anchor">
        <Drawer
          anchor={"right"}
          open={stateAsk}
          onClose={() => closeDrawer()}
        >
          <Grid className={classes.btnClose}>
            <IconButton onClick={() => closeDrawer()} aria-label="filter" className={classes.btnFilter}>
              <CloseIcon fill='#BCBBD0' />
            </IconButton>
          </Grid>
          {
            props.AskCFT
              ?
              <React.Fragment>
                {
                  answer === 1
                    ?
                    listSubmitTrue('right')
                    :
                    answer === 0
                      ?
                      listSubmitFalse('right')
                      :
                      list()
                }
              </React.Fragment>
              :
              <React.Fragment><DropZone /></React.Fragment>
          }
        </Drawer>
      </React.Fragment>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: 64,

    [theme.breakpoints.down(500)]: {
      padding: 24,
    },
  },

  list: {
    width: 600,

    [theme.breakpoints.down(696)]: {
      width: '100%',
    },
  },

  fullList: {
    width: 'auto',
  },

  listHeader: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '28px',
    lineHeight: '40px',
    color: "#24262A"
  },

  btnClose: {
    position: 'absolute',
    right: 12,
    top: 12,

    [theme.breakpoints.down(500)]: {
      zIndex: 1,
      borderRadius: '50%',
      backgroundColor: '#FFFFFF',
    }
  },

  Body1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2'
  },

  Info1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
    color: '#BCBBD0'
  },

  Caption1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '13px',
    lineHeight: '28px',
    display: 'flex',
    alignItems: 'center',
  },

  LinkType11: {
    color: 'inherit',
    textDecoration: 'none',
    borderBottom: '1px solid',
    borderColor: 'inherit',

    '&:hover': {
      color: '#2050FF',
      textDecoration: 'none',
      borderBottom: '1px solid #2050FF',
    }
  },

  ActionArea: {
    marginTop: 0,
    justifyContent: "space-between",
    marginTop: 11,
    maxWidth: 472,
  }
}));